import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";
import {useAddProductCategory,useCategoryParentID,useCategoryType,useDeleteProductCategory,useGetProduct,
  useUpdateProductCAategory,
} from "../useProduct";
import { handleMedia } from "../../edetailing/repository/EdetailingRepository";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { FaTrash } from "react-icons/fa";
interface CategoryModalContentProps {
  handleClose: () => void;
  mode?: string;
  id?: number | undefined;
}

interface formInteface {
  categoryName: string;
  description: string;
  file: any;
  CategoryDisplayOrder?: number | undefined;
  orgUnit: string | any;
  categoryType: string | any;
  parent?: number | undefined;
}

const CategoryModalContent: React.FC<CategoryModalContentProps> = ({
  handleClose,
  mode,
  id,
}) => {
  const { data, isLoading, isSuccess } = useGetProduct({
    enable: !!id,
    params: {
      categoryId: id,
    },
  });

  const [formData, setFormData] = useState<formInteface>({
    categoryName: "",
    description: "",
    file: "",
    CategoryDisplayOrder: undefined,
    orgUnit: "",
    categoryType: "",
    parent: undefined,
  });

  useEffect(() => {
    if (mode === "edit" && isSuccess && data?.data) {
      setFormData({
        categoryName: data?.data?.CategoryName || "",
        description: data?.data?.CategoryDescription || "",
        file: data?.data?.CategoryMedia || "",
        CategoryDisplayOrder: data?.data?.CategoryDisplayOrder,
        orgUnit: data?.data?.OrgunitId,
        categoryType: data?.data?.CategoryType || "",
        parent: data?.data?.CategoryParentId,
      });
    }
  }, [mode, isSuccess, data]);

  const BASE_URL = "https://tspc-development.truesales.in/media?id=";
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        setFormData((prev) => ({ ...prev, file: mediaId }));
      } catch (error) {
        console.error("Media upload failed:", error);
      }
    }
  };

  // API
  const { mutate: UpdateProductCategory } = useUpdateProductCAategory();
  const { mutate: deleteProductCategory } = useDeleteProductCategory();
  const { data: orgUnitsData } = useGetOrgUnitsData({ enable: true });
  const { mutate: addProductCategory } = useAddProductCategory();
  const { data: CategotyTypeDropDownData } = useCategoryType({ enable: true });

  const formattedOrgUnitData = Object.entries(orgUnitsData?.data || {}).map(
    ([key, value]) => ({
      id: Number(key),
      label: String(value),
    })
  );

  const { data: CategoryParentId } = useCategoryParentID({ enable: true });
  const formatedCategoryParentData = Object.entries(
    CategoryParentId?.data?.CategoryParentId || {}
  ).map((item: any, label: any) => ({
    id: item[0],
    label: item[1],
  }));

  const formatedDataforCategoryType = Object.entries(
    CategotyTypeDropDownData?.data || {}
  ).map((item: any, label: any) => ({
    id: item[0],
    label: item[1],
  }));

  const handleDeletehandleDelete = () => {
    // API hit
    const ID: any = id;
    deleteProductCategory({ id: ID });
    handleClose();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) {
      const body = {
        OrgunitId: Number(formData.orgUnit),
        CategoryType: formData.categoryType,
        CategoryName: formData.categoryName,
        CategoryDescription: formData.description,
        CategoryDisplayOrder: Number(formData.CategoryDisplayOrder),
        CategoryParentId: Number(formData.parent),
        CategoryMedia: String(formData.file),
      };
      addProductCategory({ ReqBody: body });
    }

    if (id) {
      // Update
      const updateBody = {
        OrgunitId: Number(formData.orgUnit),
        CategoryName: formData.categoryName,
        CategoryDescription: formData.description,
        CategoryDisplayOrder: Number(formData.CategoryDisplayOrder),
        CategoryParentId: Number(formData.parent),
        CategoryType: formData.categoryType,
        CategoryMedia: String(formData.file),
      };
      UpdateProductCategory({ ReqBody: updateBody, id: id });
    }
    handleClose();
  };


  return (
    <form onSubmit={handleSubmit}>
      <div className="row mb-0 col-sm-12">
        <div className="col-sm-6">
          {/* First Input */}
          <label style={{ fontWeight: "500", marginTop: "8px" }}>
            Category Name<span style={{color:'red'}} >*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter category name"
            value={formData.categoryName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFormData((prev) => ({
                ...prev,
                categoryName: e.target.value,
              }))
            }
            style={{
              // border: "2px solid #EDEDED",
              border: ".5px solid #e0e0e0",
              borderRadius: "4px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>

        <div className="col-sm-6 mt-0">
          {/* First Dropdown */}
          <ReusableDropdown
            options={formattedOrgUnitData || []}
            value={formData.orgUnit}
            onChange={(value: any) => {
              setFormData((prev) => ({
                ...prev,
                orgUnit: value,
              }));
            }}
            DropdownHeading="Select Org Unit"
          />
        </div>
      </div>

      <div className="row mb-0 col-sm-12">
        <div className="col-sm-6">
          <ReusableDropdown
            options={formatedDataforCategoryType || []}
            value={formData.categoryType}
            onChange={(value: any) => {
              setFormData((prev) => ({
                ...prev,
                categoryType: value,
              }));
            }}
            DropdownHeading="Category Type"
          />
        </div>

        <div className="col-sm-6">
          <ReusableDropdown
            options={formatedCategoryParentData || []}
            value={formData.parent}
            onChange={(value: any) => {
              setFormData((prev) => ({
                ...prev,
                parent: value,
              }));
            }}
            DropdownHeading="Parent"
          />
        </div>
      </div>

      {/* Second Input */}
      <label className="mt-2" style={{ fontWeight: "500" }}>
        Description<span style={{color:'red'}} >*</span>
      </label>

      <input
        required={true}
        type="text"
        placeholder="Enter description"
        className="form-control"
        value={formData.description}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFormData((prev) => ({
            ...prev,
            description: e.target.value,
          }))
        }
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "8px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
      />

      {/* third Input */}
      <label className="mt-2" style={{ fontWeight: "500" }}>
        Order<span style={{color:'red'}} >*</span>
      </label>
      <input
        type="number"
        min="1"
        className="form-control"
        value={formData.CategoryDisplayOrder}
        onChange={(e: any) => {
          const order: number = e.target.value;
          setFormData((prev) => ({
            ...prev,
            CategoryDisplayOrder: order,
          }));
        }}
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "8px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
      />

      {/* File Upload */}
      <label className="mt-2" style={{ fontWeight: "500" }}>
        Upload media
      </label>

      <input
        type="file"
        className="form-control"
        accept="image/*"
        id="mediaUpload"
        onChange={(e) => handleFileChange(e)}
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "4px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
          color: "red",
        }}
      />
      <div className="row mb-3">
        {(id || formData.file) && (
          <div className="col-md-6" style={{ marginBottom: "10px" }}>
            {/* <label style={{ fontWeight: "500", display: "block" }}>
              Uploaded Media
            </label> */}

            {formData.file && (
                <div 
                style={{
                position: "relative",
                width: "fit-content",
              }}>
                <img
                  src={
                    formData.file
                      ? `${BASE_URL}${formData.file}`
                      : "https://via.placeholder.com/100?text=No+Image"
                  }
                  alt={formData.file ? "Uploaded Media" : "Dummy Image"}
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "8px",
                    marginTop: "8px",
                  }}
                />
                <span
                  onClick={() => {
                    setFormData((prevState: any) => ({
                      ...prevState,
                      file: "",
                      mediaFile: null,
                    }));

                    // ✅ Clear input value
                    const fileInput = document.getElementById(
                      "mediaUpload"
                    ) as HTMLInputElement;
                    if (fileInput) fileInput.value = "";
                  }}
                  style={{
                    position: "absolute",
                    top: "-6px",
                    right: "-8px",
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "50%",
                    padding: "2px 6px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  <FaTrash size={10} color="red" />
                </span>
             </div>
            )}
          </div>
        )}
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
        >
          {mode === "add" ? "Submit" : "Update"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
        {/* { mode === 'edit' &&(
        <Btn
          style={{
            backgroundColor: "#ff5b5b",
            color: "#000",
            border: "1px solid#E0E0E0",
          }}
          type="button"
          onClick={handleDeletehandleDelete}
        >
          Delete
        </Btn>)
        } */}
      </div>
    </form>
  );
};

export default CategoryModalContent;
